import * as React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ClassLockedStateProps {
  className?: string;
}

export function ClassLockedState({ className }: ClassLockedStateProps) {
  return (
    <Card
      data-testid="class-locked"
      className={cn("flex flex-col items-center text-center gap-4 p-8 max-w-md mx-auto", className)}
    >
      <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center">
        <Lock className="w-7 h-7 text-slate-400" />
      </div>
      <div className="space-y-2">
        <h2 className="text-lg font-semibold text-slate-900">
          Class Management is available on Gold and Platinum
        </h2>
        <p className="text-sm text-slate-500">
          Upgrade your plan to access class management features.
        </p>
      </div>
      <Button asChild variant="default" className="cursor-pointer transition-colors duration-150">
        <Link to="/teacher-subscription">Upgrade now</Link>
      </Button>
    </Card>
  );
}
